module.exports = __webpack_public_path__ + "media/Loops Bass.550de01d.wav";